module.exports = __webpack_public_path__ + "static/header@2x-b321606f24ad9001443c8caf9ee7a8c5.jpg";